import { createClient } from "@supabase/supabase-js";

import env from "@/utils/environmentHelpers";

const { supabaseUrl, supabasePublishableKey } = env;
export const hasSupabaseConfig = Boolean(supabaseUrl && supabasePublishableKey);

let supabaseClient: ReturnType<typeof createClient> | null = null;

export const getSupabaseClient = () => {
  if (!supabaseUrl || !supabasePublishableKey) {
    throw new Error(
      "Missing Supabase configuration. Please set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY.",
    );
  }

  if (!supabaseClient) {
    supabaseClient = createClient(supabaseUrl!, supabasePublishableKey!);
  }

  return supabaseClient;
};
